import React, { useEffect, useState } from "react";
import Title_Section from "../../components/Title_Section/Title_Section";
import {
  Grid,
  IconButton,
  TableCell,
  TableRow,
  Tooltip
} from "@mui/material";
import Button from "../../components/Button";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { ROUTE_PATHS } from "../../utils/PathsNames";
import Table from "../../components/Table";
import { useDispatch, useSelector } from "react-redux";
import { getAllPackagesRequest } from "../../store/Packages/actions";
import { useHistory } from "react-router-dom";
import PackagesDelete from "./PackagesDelete/PackagesDelete";
import messages from "../../assets/locale/messages";
// import PropTypes from 'prop-types'

function PackageList() {
  const lang = useSelector((state) => state.locale.lang);

  const {
    package: {
      title,
      addTitle,
      headlines,
      deleteMessage,
      deletePackage,
      error: { errPackage }
    },
    shared: { deleteLabel, editLabel, viewLabel }
  } = messages[lang];
  const histpory = useHistory();
  const dispatch = useDispatch();
  const [deleteModal, setDeleteModal] = useState({
    id: 0,
    isOpen: false
  });
  const packages = useSelector(
    (state) => state?.packagesReducer.packages
  );
  useEffect(() => {
    dispatch(getAllPackagesRequest());
  }, []);

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <Title_Section title={title} />
        <Grid container spacing={3}>
          <Grid item xs={6}>
            {/* <Filters /> */}
          </Grid>
          <Grid
            item
            xs={6}
            className="d-flex align-items-start justify-content-end"
          >
            <Button
              text={addTitle}
              icon={<AddIcon className="me-2" />}
              isLink={true}
              slug={`${ROUTE_PATHS.packageForm}/Add`}
            />
          </Grid>
        </Grid>
      </div>
      <Table
        hasActions={true}
        headlines={headlines}
        rows={
          packages?.length > 0 ? (
            <>
              {packages?.map((Package) => (
                <TableRow className="table__row" key={Package.id}>
                  <TableCell className="table__cell">
                    {Package.name}
                  </TableCell>
                  <TableCell className="table__cell">
                    {Package?.items?.map((item) => (
                      <p
                        style={{ marginBottom: "0px" }}
                        key={item.id}
                      >
                        {item.title}
                      </p>
                    ))}
                  </TableCell>
                  <TableCell className="table__cell">
                    {Package?.price}
                  </TableCell>
                  <TableCell className="table__cell" align="right">
                    <Tooltip title={viewLabel}>
                      <IconButton
                        onClick={() => {
                          histpory.push(
                            `${ROUTE_PATHS.packageForm}/View/${Package.id}`
                          );
                        }}
                        aria-label="view"
                      >
                        <VisibilityIcon
                          className="table__view"
                          fontSize="medium"
                        />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={editLabel}>
                      <span>
                        <IconButton
                          onClick={() =>
                            histpory.push(
                              `${ROUTE_PATHS.packageForm}/Edit/${Package.id}`
                            )
                          }
                          aria-label="edit"
                        >
                          <EditIcon
                            className="table__edit"
                            fontSize="medium"
                          />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip title={deleteLabel}>
                      <span>
                        <IconButton
                          onClick={() =>
                            setDeleteModal({
                              id: Package.id,
                              isOpen: true
                            })
                          }
                          aria-label="delete"
                        >
                          <DeleteIcon
                            className={`table__delete`}
                            fontSize="medium"
                          />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </>
          ) : (
            <TableRow>
              <h4>{errPackage}</h4>
            </TableRow>
          )
        }
      />
      <PackagesDelete
        setDeleteModal={setDeleteModal}
        deleteMessage={deleteMessage}
        deletePackage={deletePackage}
        isOpen={deleteModal.isOpen}
        id={deleteModal.id}
      />
    </div>
  );
}

PackageList.propTypes = {};

export default PackageList;
